/*!
=========================================================
* Regiform IMS Frontend - Bottom Notification Component
=========================================================
* Fixed bottom notification bar (same style as PrintIndicator)
* Supports warning, error, info, success types
* Auto-dismisses after configurable duration
=========================================================
*/

import { WarningOutlined, CloseCircleOutlined, InfoCircleOutlined, CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useBottomNotificationStore } from "../../stores/bottomNotificationStore";
import "./BottomNotification.css";

const TYPE_CONFIG = {
  warning: {
    gradient: "linear-gradient(90deg, #faad14 0%, #ffc53d 100%)",
    shadow: "rgba(250, 173, 20, 0.3)",
    icon: WarningOutlined,
  },
  error: {
    gradient: "linear-gradient(90deg, #ff4d4f 0%, #ff7875 100%)",
    shadow: "rgba(255, 77, 79, 0.3)",
    icon: CloseCircleOutlined,
  },
  info: {
    gradient: "linear-gradient(90deg, #1890ff 0%, #40a9ff 100%)",
    shadow: "rgba(24, 144, 255, 0.3)",
    icon: InfoCircleOutlined,
  },
  success: {
    gradient: "linear-gradient(90deg, #52c41a 0%, #73d13d 100%)",
    shadow: "rgba(82, 196, 26, 0.3)",
    icon: CheckCircleOutlined,
  },
};

const BottomNotification = () => {
  const notifications = useBottomNotificationStore((s) => s.notifications);
  const dismissNotification = useBottomNotificationStore((s) => s.dismissNotification);

  if (notifications.length === 0) {
    return null;
  }

  // Show the latest notification
  const notification = notifications[notifications.length - 1];
  const config = TYPE_CONFIG[notification.type] || TYPE_CONFIG.warning;
  const IconComponent = config.icon;

  return (
    <div
      className="bottom-notification"
      style={{
        background: config.gradient,
        boxShadow: `0 -2px 8px ${config.shadow}`,
      }}
    >
      <div className="bottom-notification-content">
        <IconComponent className="bottom-notification-icon" />
        <span className="bottom-notification-text">{notification.message}</span>
        <CloseOutlined
          className="bottom-notification-close"
          onClick={() => dismissNotification(notification.id)}
        />
      </div>
    </div>
  );
};

export default BottomNotification;
